<template>
  <section id="main">
    <router-view @back="handleBack" />
    <Snackbar />
  </section>
</template>

<script>
import 'hooper/dist/hooper.css';

export default {
  name: 'ItemMitraApp',
  mounted() {
    this.$nativeBridge.setTopBar(JSON.stringify({ hidden: true }));

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden)
        this.$nativeBridge.setTopBar(JSON.stringify({ hidden: true }));
    });
  },
  methods: {
    handleBack() {
      if (window.android) {
        window.android.back();
      } else {
        this.$router.back();
      }
    },
  },
};
</script>
